
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import SFaqList from '~/components/Sanity/SFaqList.vue';
import { ProjectPageVariation } from '~/types/sanity-documents';

@Component({
  components: {
    SFaqList,
  },
})
export default class ProjectTabs extends Vue {
  @Prop(String) readonly id!: string;

  variations = ProjectPageVariation;

  get variation() {
    return this.$sanityLookup.getSiteConfig()?.data?.projectPageVariation;
  }
}
